export default class CheckboxModel {
    constructor(
        labelText: string,
        checkboxValue: string,
        selectionValue: boolean) {
            this.labelText = labelText
            this.checkboxValue = checkboxValue
            this.selectionValue = selectionValue
        }

    labelText: string
    checkboxValue: string
    selectionValue: boolean

    static createEmpty(): CheckboxModel {
        return new CheckboxModel("", "", false)
    }
}
